import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Dropdown from "../ui/Dropdown";
import { setCabinetGLBFromCabinetsSet } from "../../helpers/sqft3dArHelper";
import { setSQFTViewMode } from "../../../../actions/sqftFunctions";
import { prepareSQFTData } from "../canvas/core/workspace/workspaceDataMapper";
import workspace from "../canvas/core/workspace";
import { SQFT_VIEW_MODE } from "../../constants";
import {setSQFTActiveLevel3Button} from "../../../../actions/sqftMenuFunctions";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";

const SQFTModeDropdown = (props) => {
  const { SQFTViewMode, setSQFTViewMode, setSQFTActiveLevel3Button, setGroheFiltersSearchText } = props;
  const [activeItem, setActiveItem] = useState(null);

  const items = [
    { label: "2d Mode", value: SQFT_VIEW_MODE.twoDMode },
    { label: "3d Mode", value: SQFT_VIEW_MODE.threeDMode },
    { label: "Augmented Reality", value: SQFT_VIEW_MODE.augmentedReality },
    { label: "Augmented Reality Doors", value: SQFT_VIEW_MODE.augmentedRealityDoors },
  ];

  useEffect(() => {
    const selectedItem = items.find(item => item.value === SQFTViewMode) || items[0];
    if (!activeItem || selectedItem.value !== activeItem.value) {
      setActiveItem(selectedItem);
    }
  }, [SQFTViewMode, items, activeItem]);

  const handleItemSelect = async (item) => {
    setActiveItem(item);
    setSQFTViewMode(item.value);
    setSQFTActiveLevel3Button(null);
    setGroheFiltersSearchText("");

    let sqftCalcData;
    switch (item.value) {
      case SQFT_VIEW_MODE.threeDMode:
      case SQFT_VIEW_MODE.augmentedReality:
        await setCabinetGLBFromCabinetsSet().then(r => void r);
        break;
      case SQFT_VIEW_MODE.threeDModeDoors:
      case SQFT_VIEW_MODE.augmentedRealityDoors:
        await setCabinetGLBFromCabinetsSet(true).then(r => void r);
        break;
      case SQFT_VIEW_MODE.twoDMode:
        sqftCalcData = await prepareSQFTData();
        workspace.import(sqftCalcData);
        break;
    }
  };

  const handleDropdownSelect = async (prevIsOpen) => {
    void prevIsOpen;
    setSQFTActiveLevel3Button(null);
    setGroheFiltersSearchText("");
  };

  return (
    <Dropdown
      className={"dropdown-mode ui-select"}
      items={items}
      activeItem={activeItem}
      onItemSelect={handleItemSelect}
      onDropdownSelect={handleDropdownSelect}
      isOpenInitially={false}
    />
  );
};

const mapStateToProps = (store) => ({
  windowWidth: store.serverState.windowWidth,
  SQFTViewMode: store.sqftState.SQFTViewMode,
});

const mapDispatchToProps = {
  setSQFTViewMode,
  setSQFTActiveLevel3Button,
  setGroheFiltersSearchText
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SQFTModeDropdown)
);
